export const loadFeedAttachableLinkLoadParams = (): Promise<typeof import('./feedAttachableLink')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-attachablelink" */ './feedAttachableLink');

export const loadFeedGroupAgentSuggestionsLoadParams = (): Promise<typeof import('./feedGroupAgentSuggestions')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-groupagentsuggestions" */ './feedGroupAgentSuggestions');

export const loadFeedGroupLoadParams = (): Promise<typeof import('./feedGroup')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-group" */ './feedGroup');

export const loadFeedGroupTopQuestionsLoadParams = (): Promise<typeof import('./feedGroupTopQuestions')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-grouptopquestions" */ './feedGroupTopQuestions');

export const loadFeedGroupSimilarQuestionsLoadParams = (): Promise<typeof import('./feedGroupSimilarQuestions')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-grouptopquestions" */ './feedGroupSimilarQuestions');

export const loadFeedCampaignLoadParams = (): Promise<typeof import('./feedCampaign')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-campaign" */ './feedCampaign');

export const loadFeedHomeLoadParams = (): Promise<typeof import('./feedHome')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-home" */ './feedHome');

export const loadFeedMoreForYouLoadParams = (): Promise<typeof import('./feedMoreForYou')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-moreforyou" */ './feedMoreForYou');

export const loadFeedLiveEventLoadParams = (): Promise<typeof import('./feedEvent')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-liveevent" */ './feedEvent');

export const loadFeedAllStorylineLoadParams = (): Promise<typeof import('./feedAllStoryline')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-allstoryline" */ './feedAllStoryline');

export const loadFeedDiscoveryStorylineLoadParams = (): Promise<typeof import('./feedDiscoveryStoryline')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-discoverystoryline" */ './feedDiscoveryStoryline');

export const loadFeedFollowedStorylineLoadParams = (): Promise<typeof import('./feedFollowedStoryline')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-followedstoryline" */ './feedFollowedStoryline');

export const loadFeedTeamsMeetingLoadParams = (): Promise<typeof import('./feedTeamsMeeting')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-teamsmeeting" */ './feedTeamsMeeting');

export const loadFeedUserLoadParams = (): Promise<typeof import('./feedUser')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-user" */ './feedUser');

export const loadFeedLeaderEmployeesLoadParams = (): Promise<typeof import('./feedLeaderEmployees')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-leaderemployees" */ './feedLeaderEmployees');

export const loadFeedLeaderHighlightedLoadParams = (): Promise<typeof import('./feedLeaderHighlighted')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-leaderhighlighted" */ './feedLeaderHighlighted');

export const loadFeedInboxDraftLoadParams = (): Promise<typeof import('./feedInboxDraftThreads')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-inboxdraft" */ './feedInboxDraftThreads');

export const loadFeedInboxScheduledLoadParams = (): Promise<typeof import('./feedInboxScheduledThreads')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-inboxscheduled" */ './feedInboxScheduledThreads');

export const loadFeedBookmarkLoadParams = (): Promise<typeof import('./feedBookmark')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-bookmark" */ './feedBookmark');

export const loadFeedUserWallLoadParams = (): Promise<typeof import('./feedUserWall')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-userwall" */ './feedUserWall');

export const loadFeedNetworkQuestionLoadParams = (): Promise<typeof import('./feedNetworkQuestion')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-networkquestion" */ './feedNetworkQuestion');

export const loadFeedNetworkQuestionInboxLoadParams = (): Promise<typeof import('./feedNetworkQuestionInbox')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-networkquestioninbox" */ './feedNetworkQuestionInbox');

export const loadFeedDiscoveryNetworkQuestionLoadParams = (): Promise<
  typeof import('./feedDiscoveryNetworkQuestion')
> => import(/* webpackChunkName: "4-feat-feedloadparams-discoverynetworkquestion" */ './feedDiscoveryNetworkQuestion');

export const loadFeedNetworkThemeLoadParams = (): Promise<typeof import('./feedNetworkTheme')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-networktheme" */ './feedNetworkTheme');

export const loadFeedMyLeadersLoadParams = (): Promise<typeof import('./feedMyLeaders')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-myleaders" */ './feedMyLeaders');

export const loadFeedPromotedLoadParams = (): Promise<typeof import('./feedPromoted')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-promoted" */ './feedPromoted');

export const loadFeedTopicUnifiedLoadParams = (): Promise<typeof import('./feedTopicUnified')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-topicunified" */ './feedTopicUnified');

export const loadFeedUserGroupsLoadParams = (): Promise<typeof import('./feedUserGroups')> =>
  import(/* webpackChunkName: "4-feat-feedloadparams-usergroups" */ './feedUserGroups');
